import { createFileRoute, redirect } from '@tanstack/react-router';

// CPH-003: the FSU Filings page retires. Its filed-report archive view
// is served by `/admin/finance/reports` (ReportListPage already filters
// by status); the work-in-progress view is absorbed into the Close hub
// spine (Phase 3 lands in CPH-014). Bookmarks redirect to /close.
export const Route = createFileRoute('/admin/finance/filings')({
  beforeLoad: () => {
    throw redirect({ to: '/admin/finance/close' });
  },
});
